import { render, staticRenderFns } from "./DistributionOptions.vue?vue&type=template&id=48a2fe88&"
import script from "./DistributionOptions.vue?vue&type=script&lang=ts&"
export * from "./DistributionOptions.vue?vue&type=script&lang=ts&"
import style0 from "./DistributionOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VFlex,VIcon,VLayout,VSelect,VTextField,VTooltip})
